module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplates) ? _c('b-modal', {
    ref: "missionApplySlotTemplateModal",
    attrs: {
      "id": "missionApplySlotTemplateModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.apply.slotTemplate'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionApplySlotTemplateData
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.applySlotTemplateToMission($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.apply.slotTemplate.description'))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotTemplate.filter'),
      "description": _vm.$t('mission.slotTemplate.filter.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionSlotTemplateFilter),
      callback: function($$v) {
        _vm.missionSlotTemplateFilter = $$v
      },
      expression: "missionSlotTemplateFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.slotTemplate.insertAfter'),
      "description": _vm.$t('mission.slotTemplate.insertAfter.description')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.missionSlotTemplateInsertAfterOptions
    },
    model: {
      value: (_vm.missionSlotTemplateInsertAfter),
      callback: function($$v) {
        _vm.missionSlotTemplateInsertAfter = $$v
      },
      expression: "missionSlotTemplateInsertAfter"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "22%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredMissionSlotTemplates), function(missionSlotTemplate) {
    return _c('tr', {
      key: missionSlotTemplate.uid
    }, [_c('td', [_vm._v(_vm._s(missionSlotTemplate.title))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'userDetails',
          params: {
            userUid: missionSlotTemplate.creator.uid
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.formatUserWithTag(missionSlotTemplate.creator)))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(missionSlotTemplate.slotGroupCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(missionSlotTemplate.slotCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-btn', {
      attrs: {
        "variant": "primary",
        "size": "sm",
        "to": {
          name: 'missionSlotTemplateDetails',
          params: {
            missionSlotTemplateUid: missionSlotTemplate.uid
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n                    ")]), _vm._v(" "), _c('b-btn', {
      attrs: {
        "variant": "success",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.applySlotTemplateToMission(missionSlotTemplate.uid)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('button.apply.mission.slotGroup.short')) + "\n                    ")])], 1)])
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filteredMissionSlotTemplates.length >= 10),
      expression: "filteredMissionSlotTemplates.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.title')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.list.creator')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots.groups')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.list.counts.slots')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "22%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])])])], 1), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission apply slot template actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionConvertToSlotTemplateModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.cancel')) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d5e79c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionApplySlotTemplateModal.vue
// module id = 518
// module chunks = 0